import React, { useState, useMemo } from "react";
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Departments.css";

const INITIAL_DEPARTMENTS = [
  { id: 1, name: "All Departments", dailyLimit: "", order: 1 },
  { id: 2, name: "CROWN AND BRIDGE", dailyLimit: "0", order: 2 },
  { id: 3, name: "IMPLANTS", dailyLimit: "", order: 3 },
  { id: 4, name: "ORTHODONTIC", dailyLimit: "0", order: 4 },
];

const PAGE_SIZE = 10;

const Departments = () => {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState(INITIAL_DEPARTMENTS);
  const [search, setSearch] = useState("");
  const [sortKey, setSortKey] = useState("order");
  const [sortDir, setSortDir] = useState("asc");
  const [page, setPage] = useState(1);

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setSortDir("asc");
    }
  };

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    const list = departments.filter((d) => d.name.toLowerCase().includes(q));
    const sorted = [...list].sort((a, b) => {
      let av = a[sortKey];
      let bv = b[sortKey];
      if (sortKey === "order" || sortKey === "dailyLimit") {
        av = av === "" ? -1 : Number(av);
        bv = bv === "" ? -1 : Number(bv);
      } else {
        av = String(av).toLowerCase();
        bv = String(bv).toLowerCase();
      }
      if (av < bv) return sortDir === "asc" ? -1 : 1;
      if (av > bv) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [departments, search, sortKey, sortDir]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const pageRows = filtered.slice(startIndex, startIndex + PAGE_SIZE);

  const showingFrom = filtered.length === 0 ? 0 : startIndex + 1;
  const showingTo = startIndex + pageRows.length;

  // ✅✅✅ YAHI FIX THA — pehle sirf console.log tha, ab navigate karta hai
  const handleAdd = () => {
    navigate("/add-department");
  };

  const handleEdit = (dept) => {
    navigate(`/edit-department/${dept.id}`);
  };

  const handleDelete = (dept) => {
    if (window.confirm(`Delete "${dept.name}"?`)) {
      setDepartments((prev) => prev.filter((d) => d.id !== dept.id));
    }
  };

  const SortIcon = ({ column }) => (
    <span className="dp-sort-icon">
      <span className={sortKey === column && sortDir === "asc" ? "dp-sort-active" : ""}>▲</span>
      <span className={sortKey === column && sortDir === "desc" ? "dp-sort-active" : ""}>▼</span>
    </span>
  );

  return (
    <div className="dp-wrapper">
      <h2 className="dp-title">Departments</h2>

      <div className="dp-card">
        <div className="dp-toolbar">
          <div className="dp-search-box">
            <label className="dp-search-label" htmlFor="dp-search">Search</label>
            <input
              id="dp-search"
              type="text"
              className="dp-search-input"
              placeholder="Type to search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
          </div>

          <Dropdown as={ButtonGroup} className="dp-split">
            <Button className="dp-btn" onClick={handleAdd}>+ Add</Button>
            <Dropdown.Toggle split className="dp-btn dp-btn-toggle" id="dp-add-toggle" />
            <Dropdown.Menu align="end">
              <Dropdown.Item onClick={handleAdd}>Add Department</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="dp-table-responsive">
          <table className="dp-table">
            <thead>
              <tr>
                <th className="dp-th-sortable" onClick={() => handleSort("name")}>
                  <span className="dp-th-inner">Name <SortIcon column="name" /></span>
                </th>
                <th className="dp-th-sortable" onClick={() => handleSort("dailyLimit")}>
                  <span className="dp-th-inner">Daily Limit <SortIcon column="dailyLimit" /></span>
                </th>
                <th className="dp-th-sortable" onClick={() => handleSort("order")}>
                  <span className="dp-th-inner">Order <SortIcon column="order" /></span>
                </th>
                <th className="dp-th-action"></th>
              </tr>
            </thead>
            <tbody>
              {pageRows.length === 0 ? (
                <tr>
                  <td colSpan={4} className="dp-empty">No departments found</td>
                </tr>
              ) : (
                pageRows.map((dept) => (
                  <tr key={dept.id}>
                    <td>{dept.name}</td>
                    <td>{dept.dailyLimit}</td>
                    <td>{dept.order}</td>
                    <td className="dp-td-action">
                      <Dropdown as={ButtonGroup} className="dp-split">
                        <Button className="dp-btn dp-btn-sm" onClick={() => handleEdit(dept)}>Edit</Button>
                        <Dropdown.Toggle split className="dp-btn dp-btn-sm dp-btn-toggle" id={`dp-edit-${dept.id}`} />
                        <Dropdown.Menu align="end">
                          <Dropdown.Item onClick={() => handleEdit(dept)}>Edit</Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDelete(dept)}>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="dp-footer">
          <div className="dp-info">
            Showing {showingFrom} to {showingTo} of {filtered.length} entries
          </div>
          <div className="dp-pagination">
            <button className="dp-page-btn" disabled={currentPage === 1} onClick={() => setPage(1)}>First</button>
            <button className="dp-page-btn" disabled={currentPage === 1} onClick={() => setPage(currentPage - 1)}>Previous</button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                className={`dp-page-btn ${p === currentPage ? "dp-page-active" : ""}`}
                onClick={() => setPage(p)}
              >
                {p}
              </button>
            ))}
            <button className="dp-page-btn" disabled={currentPage === totalPages} onClick={() => setPage(currentPage + 1)}>Next</button>
            <button className="dp-page-btn" disabled={currentPage === totalPages} onClick={() => setPage(totalPages)}>Last</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Departments;